export const APP_MSG = "useApp must be used in AppProvider"
export const AUTHENTICATION_MSG = "useAuthentication must be used in AuthenticationProvider"
export const USER_MSG = "useUser must be used in UserProvider"